<template>
  <v-btn
    @click="$emit(`click`)"
    :block="block"
    :disabled="disabled"
    :loading="loading"
    :to="to"
    :height="height"
    :width="width"
    depressed
    class="secondary-btn rounded"
  >
    <span :class="{ 'secondary-btn__content': !disabled, [buttonText]: true, }">
      <slot></slot>
    </span>
  </v-btn>
</template>

<style lang="scss">
.secondary-btn {
  background-color: var(--v-secondary-button) !important;
  border: 1.5px solid #123262;

  &__content {
    color: var(--v-secondary-button-text-base);
  }
}
.secondary-btn:disabled {
  border: unset
}
</style>

<script lang="ts">
import Vue from 'vue'

export default Vue.extend({
  name: 'SecondaryButton',

  props: {
    block: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    to: String,
    rounded: {
      type: Number,
      default: 1
    },
    height: {
      type: Number,
      default: 50,
    },
    width: Number,
    buttonText: {
      type: String,
      default: 'text-h3',
    },
  },
})
</script>
